var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickupOngoing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ffdb00",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 30.375 9.563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.47 7.567a.28.28 0 0 0-.15-.151l-8.9-3.762a.278.278 0 0 0-.365.147l-2.748 6.465a.279.279 0 0 0 .148.365l8.9 3.762a.272.272 0 0 0 .213.002.278.278 0 0 0 .152-.149l2.747-6.466a.28.28 0 0 0 .002-.213",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#013177",
    d: "M11.477 16.458 18.352.278l-6.875 16.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.477 16.737a.278.278 0 0 1-.257-.387L18.096.17a.278.278 0 0 1 .513.217l-6.876 16.18a.278.278 0 0 1-.256.17",
    stroke: "#000",
    strokeWidth: 0.844,
    fill: "#FFBC53",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.78 2.27 18.46.023a.28.28 0 0 0-.364.148l-.55 1.292a.277.277 0 0 0 .148.364l5.319 2.25a.279.279 0 0 0 .365-.148l.55-1.293a.278.278 0 0 0-.148-.364M12.572 13.881 1.374 9.146a.28.28 0 0 0-.366.148l-.986 2.321a.28.28 0 0 0 .148.365l11.198 4.734a.28.28 0 0 0 .213.002.276.276 0 0 0 .152-.149l.987-2.321a.278.278 0 0 0-.148-.365",
    stroke: "#000",
    strokeWidth: 0.717,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.869 13.183a3.574 3.574 0 0 0-4.676 1.887 3.558 3.558 0 0 0 3.28 4.946c1.389 0 2.712-.815 3.287-2.17a3.558 3.558 0 0 0-1.891-4.663",
    stroke: "#000",
    strokeWidth: 0.741,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 11.531,
    cy: 16.594,
    r: 1.406
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupOngoing);
export default __webpack_public_path__ + "static/media/pickup_ongoing.cbdc3dcbd19164f4dcdd31358492ab3d.svg";
export { ForwardRef as ReactComponent };